module.exports = __webpack_public_path__ + "img/icon_money@2x.b0b10946.png";